/**
 * Created by lk on 17/6/4.
 */
import axios from "../../utils/axios";

// 谁最懂我相关

// 列表
export function messageList(query) {
    return axios({
        url: "/admin/message/Message/notificationList",
        method: "get",
        params: query
    });
}

// 保存
export function messageSave(data, formName, method = "post") {
    var url = formName === "add" ? "/admin/message/Message/MessageAdd" : "/admin/message/Message/MessageAdd";
    return axios({
        url: url,
        method: method,
        data: data
    });
}

// 删除
export function messageDelete(query) {
    return axios({
        url: "/admin/message/Message/notificationDel",
        method: "post",
        data: {
            notification_id_arr: query.notification_id_arr
        }
    });
}

// 详情
export function notificationDetail(query) {
    return axios({
        url: "/admin/message/Message/notificationDetail",
        method: "post",
        params: {
            notification_id: query.notification_id
        }
    });
}

